import { camelCase, snakeCase } from '@replygirl/change-case-object';

// @ts-ignore
const csrfToken = document.querySelector("[name='csrf-token']")?.content || '';

const getHeaders = () => {
  return {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-type': 'application/json',
    'X-CSRF-Token': csrfToken,
  };
};

export const parseResponse = async (response: Response): Promise<any> => {
  if (!response.ok) {
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') !== -1) {
      const body = camelCase(await response.json());
      return Promise.reject({ ...body, httpStatus: response.status });
    }

    return Promise.reject(response);
  }

  const contentType = response.headers.get('content-type');
  if (contentType && contentType.indexOf('application/json') !== -1) {
    return Promise.resolve(camelCase(await response.json()));
  }

  return response.text();
};

export const getRequest = (url: string) =>
  fetch(url, {
    headers: getHeaders(),
  }).then((response: Response) => parseResponse(response));

export const postRequest = (url: string, params: any, changeCase: boolean = true) => {
  return fetch(url, {
    method: 'post',
    headers: getHeaders(),
    body: JSON.stringify(changeCase ? snakeCase(params) : params),
  }).then((response: Response) => parseResponse(response));
};

export const patchRequest = (url: string, params: any, changeCase = true) => {
  return fetch(url, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify(changeCase ? snakeCase(params) : params),
  }).then(parseResponse);
};

// Multipart form upload — the browser sets its own Content-type (with boundary),
// so this cannot reuse getHeaders(), which hardcodes application/json.
export const patchFormRequest = (url: string, formData: FormData) => {
  return fetch(url, {
    method: 'PATCH',
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: formData,
  }).then((response: Response) => parseResponse(response));
};

export const putRequest = (url: string, params: any, changeCase: boolean = true) => {
  return fetch(url, {
    method: 'put',
    headers: getHeaders(),
    body: JSON.stringify(changeCase ? snakeCase(params) : params),
  }).then((response: Response) => parseResponse(response));
};

export const deleteRequest = (url: string, params?: any, changeCase: boolean = true) => {
  return fetch(url, {
    method: 'delete',
    headers: getHeaders(),
    body: JSON.stringify(changeCase ? snakeCase(params) : params),
  }).then((response: Response) => parseResponse(response));
};
